import { TCrmGranularity } from '../../../shared/common/api/endpoints/crmAnalyticsApi';

const integerFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const decimalFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 });

const MONTHS = [ 'янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек' ];
const QUARTERS = [ 'I', 'II', 'III', 'IV' ];

export const formatNumber = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : integerFormat.format(value);

export const formatMoney = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${integerFormat.format(Math.round(value))} ₽`;

export const formatPercent = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${decimalFormat.format(value)} %`;

// Короткая запись денег для осей и плиток: 4,1 млн ₽, 353 тыс. ₽
export const formatMoneyShort = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '—';

  const abs = Math.abs(value);
  if (abs >= 1e6) return `${decimalFormat.format(value / 1e6)} млн ₽`;
  if (abs >= 1e4) return `${integerFormat.format(Math.round(value / 1e3))} тыс. ₽`;

  return formatMoney(value);
};

export const formatAxisMoney = (value: number): string => {
  const abs = Math.abs(value);
  if (abs >= 1e6) return `${decimalFormat.format(value / 1e6)} млн`;
  if (abs >= 1e3) return `${integerFormat.format(Math.round(value / 1e3))} тыс.`;

  return integerFormat.format(value);
};

export const formatDays = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${integerFormat.format(Math.round(value))} дн.`;

// Срок жизни в месяцах: 179 дн. → 5,9 мес.; меньше месяца — в днях
export const formatMonths = (days: number | null | undefined): string => {
  if (days === null || days === undefined) return '—';

  const months = days / 30.4;
  return months >= 1 ? `${decimalFormat.format(months)} мес.` : formatDays(days);
};

export const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';

  const [ year, month, day ] = value.split('-');
  return `${day}.${month}.${year}`;
};

// Подпись отрезка по его началу (ГГГГ-ММ-ДД)
export const bucketLabel = (bucket: string, granularity: TCrmGranularity): string => {
  const [ year, month, day ] = bucket.split('-');

  switch (granularity) {
    case 'day':
      return `${day}.${month}.${year.slice(2)}`;
    case 'week':
      return `с ${day}.${month}.${year.slice(2)}`;
    case 'month':
      return `${MONTHS[Number(month) - 1]} ${year}`;
    case 'quarter':
      return `${QUARTERS[Math.floor((Number(month) - 1) / 3)]} кв. ${year}`;
    default:
      return year;
  }
};

export const sumValues = (values: (number | null | undefined)[]): number =>
  values.reduce<number>((sum, value) => sum + (value ?? 0), 0);
